import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";

import { useStyles } from "../../../../Components/CSS/DetailStyle.css";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import ItemsForm from "../AddInventory/ItemsForm/ItemsForm";
import ViewDecreaseStock from "../DecreaseStock/ViewDecreaseStock/ViewDecreaseStock";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class InventoryDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemColumn: [
        { name: "S.N." },
        { name: "Item Name" },
        { name: "Quantity" },
        { name: "Rate (Per)" },
        { name: "Total" },
        { name: "PurchasedFrom" },
        { name: "PurchasedDate" },
        { name: "Actions" },
      ],
      decreaseColumn: [
        { name: "S.N." },
        { name: "Quantity" },
        { name: "Notes" },
        { name: "Actions" },
      ],
      itemDetails: {},
      items: [],
      decreases: [],
    };
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.getCategoryDetails(this.props.match.params.id);
    }
  }

  getCategoryDetails = async (categoryId) => {
    try {
      const response = await Axios.get(
        `${url}/api/item-categories/${categoryId}`,
        {
          headers: { Authorization: `Bearer ${this.props.adminToken}` },
        }
      );
      if (response.data.itemCategory) {
        this.setState({
          itemDetails: response.data.itemCategory,
          items: response.data.itemCategory.items,
          decreases: response.data.itemCategory.decrease,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getCategoryDetails(categoryId);
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { itemDetails, items, decreases } = this.state;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle
            title="Inventory Details"
            refreshUrl={this.props.match.url}
          />
          {itemDetails && (
            <div className={classes.listitemRoot}>
              <div className={classes.listitemContent}>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Category Name:-</b>
                  <div>{itemDetails.categoryName}</div>
                </ListItem>
              </div>
              <div className={classes.listitemContent}>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Current Stock:-</b>
                  <div>
                    {itemDetails.currentStock < 0
                      ? "0"
                      : itemDetails.currentStock}
                  </div>
                </ListItem>
              </div>
            </div>
          )}

          <div style={{ fontWeight: "bold", fontSize: 24 }}>
            Items Stock History
          </div>
          <ItemsForm
            column={this.state.itemColumn}
            categoryId={this.props.match.params.id}
            items={items}
            getCategoryDetails={this.getCategoryDetails}
          />

          <div style={{ fontWeight: "bold", fontSize: 24 }}>Decrease Stock</div>
          <ViewDecreaseStock
            column={this.state.decreaseColumn}
            categoryId={this.props.match.params.id}
            decreases={decreases}
            getCategoryDetails={this.getCategoryDetails}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(InventoryDetails)));
